/* CLOWN · Mobile product rails. Native scrolling, no autoplay and no cart dependency. */
(() => {
  'use strict';
  if (window.ClownProductRails) return;
  window.ClownProductRails = true;
  const mobile = matchMedia('(max-width: 749px)');
  const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const init = (scope = document) => {
    scope.querySelectorAll('[data-cr-product-rail]').forEach(rail => {
      if (rail.dataset.railReady) return;
      rail.dataset.railReady = 'true';
      const nav = rail.nextElementSibling;
      if (!nav?.matches('[data-cr-rail-nav]')) return;
      const slides = [...rail.children];
      const prev = nav.querySelector('[data-cr-rail-prev]');
      const next = nav.querySelector('[data-cr-rail-next]');
      const count = nav.querySelector('[data-cr-rail-count]');
      const abort = new AbortController();
      const { signal } = abort;
      let active = 0;
      let frame;
      const visibleSlides = () => slides.filter(slide => getComputedStyle(slide).display !== 'none');
      const positions = items => {
        const start = rail.getBoundingClientRect().left + Number.parseFloat(getComputedStyle(rail).paddingLeft || 0);
        return items.map(item => item.getBoundingClientRect().left - start + rail.scrollLeft);
      };
      const update = () => {
        frame = null;
        const items = visibleSlides();
        const enabled = mobile.matches && rail.scrollWidth > rail.clientWidth + 2 && items.length > 1;
        nav.hidden = !enabled;
        rail.tabIndex = enabled ? 0 : -1;
        if (!enabled) return;
        const distances = positions(items).map(left => Math.abs(left - rail.scrollLeft));
        active = distances.indexOf(Math.min(...distances));
        if (rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2) active = items.length - 1;
        prev.disabled = active === 0;
        next.disabled = active === items.length - 1;
        count.textContent = `${String(active + 1).padStart(2, '0')} / ${String(items.length).padStart(2, '0')}`;
      };
      const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
      const go = index => {
        const items = visibleSlides();
        const target = Math.max(0, Math.min(items.length - 1, index));
        rail.scrollTo({ left: positions(items)[target], behavior: reduced() ? 'auto' : 'smooth' });
      };
      prev.addEventListener('click', () => go(active - 1), { signal });
      next.addEventListener('click', () => go(active + 1), { signal });
      rail.addEventListener('scroll', schedule, { passive: true, signal });
      rail.addEventListener('keydown', event => {
        if (!mobile.matches || event.target !== rail) return;
        const targets = { ArrowLeft: active - 1, ArrowRight: active + 1, Home: 0, End: slides.length - 1 };
        if (!(event.key in targets)) return;
        event.preventDefault();
        go(targets[event.key]);
      }, { signal });
      rail.addEventListener('focusin', event => {
        if (!mobile.matches || event.target === rail) return;
        const items = visibleSlides();
        const index = items.findIndex(slide => slide.contains(event.target));
        if (index >= 0) go(index);
      }, { signal });
      const observer = new ResizeObserver(schedule);
      observer.observe(rail);
      slides.forEach(slide => observer.observe(slide));
      mobile.addEventListener('change', schedule, { signal });
      document.addEventListener('shopify:section:unload', event => {
        if (!event.target.contains(rail)) return;
        abort.abort(); observer.disconnect();
        if (frame) cancelAnimationFrame(frame);
      }, { signal });
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
